module.exports = __webpack_public_path__ + "img/smiley2.3bf89656.svg";